module.exports = __webpack_public_path__ + "static/media-d1eea9f5b0903043d958f50915cd0603.svg";